import Core, { defaultPayload } from './core'
import { HandlerFunction, ResponseMessage, Message } from './types'
import { IFRAME_HANDSHAKE, SYSTEM_NOTICE, LIFE_CYCLE } from '@/constants'
import { logger } from './utils/logger'
import { resSuccess } from '@/utils/common'

class ChildSDK extends Core {
  private pluginId: string = ''

  // 消息校验
  validateMessage(data: Message): boolean {
    return data.pluginId === this.pluginId
  }

  // 消息处理
  private handleMessage(event: MessageEvent): void {
    const { data } = event

    if (logger.debugger) {
      console.log('iframe通信', data)
    }

    // 校验消息
    if (!this.validateMessage(data)) return
    // 处理待响应的请求
    if (this.handlePendingRequest(data)) return
    // 处理事件监听
    this.handleEventListeners(data, async (dData, rResult) => {
      if (rResult instanceof Promise) {
        const resolvedResult = await rResult
        this.send(dData.action, resolvedResult, dData.messageId)
      } else {
        this.send(dData.action, rResult, dData.messageId)
      }
    })
  }

  constructor({ debug }: { debug: false }) {
    super()
    logger.init({
      debug,
    })
    window.addEventListener('message', this.handleMessage.bind(this))
  }

  init({
    pluginId,
    targetOrigin = '*',
  }: {
    pluginId: string
    targetOrigin?: string
  }) {
    this.pluginId = pluginId
    this.targetOrigin = targetOrigin
    this.handelChildReady()
  }

  // 通知父应用子应用已就绪
  handelChildReady(): void {
    console.log('通知父应用子应用已就绪', IFRAME_HANDSHAKE.CHILD_READY.key)
    this.send(
      IFRAME_HANDSHAKE.CHILD_READY.key,
      resSuccess({
        pluginId: this.pluginId,
        targetOrigin: this.targetOrigin,
      })
    )
  }

  // 父应用收到子应用就绪通知后，发送响应
  listenersParentAck(handler: HandlerFunction): void {
    this.on(IFRAME_HANDSHAKE.PARENT_ACK.key, handler)
  }

  // @deprecated 兼容旧的内嵌sdk
  onParentAck(handler: HandlerFunction): void {
    this.listenersParentAck(handler)
  }

  // 监听父应用语言变化
  listenersLangChange(handler: HandlerFunction): void {
    this.on(SYSTEM_NOTICE.LANGUAGE_CHANGE.key, handler)
  }

  // @deprecated 兼容旧的内嵌sdk
  onLanguageChange(handler: HandlerFunction): void {
    this.listenersLangChange(handler)
  }

  // 发送消息
  send(
    action: string,
    payload: ResponseMessage = defaultPayload,
    messageId?: string
  ) {
    this.baseSend(action, payload, this.pluginId, messageId)
  }

  // 发起请求
  async request<T = any>(
    action: string,
    payload: ResponseMessage = defaultPayload,
    timeout = this.defaultTime
  ): Promise<T> {
    const messageId = this.generateMessageId()
    return await this.baseRequest(
      action,
      payload,
      timeout,
      messageId,
      this.pluginId
    )
  }
}

// 让 UMD 也挂到 window，方便 CDN 直接使用
if (typeof window !== 'undefined') {
  ;(window as any).ChildFrameBridge = {
    sdk: ChildSDK,
    const: {
      PARENT_ACK: IFRAME_HANDSHAKE.PARENT_ACK.key,
      CHILD_READY: IFRAME_HANDSHAKE.CHILD_READY.key,
      APP_SHOW: LIFE_CYCLE.APP_SHOW.key,
      APP_HIDE: LIFE_CYCLE.APP_HIDE.key,
      APP_DESTROY: LIFE_CYCLE.APP_DESTROY.key,
      LOGIN_SUCCESS: SYSTEM_NOTICE.LOGIN_SUCCESS.key,
      NOT_LOGIN: SYSTEM_NOTICE.NOT_LOGIN.key,
      LANGUAGE_CHANGE: SYSTEM_NOTICE.LANGUAGE_CHANGE.key,
    },
  }
}
